import React from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import { Panel } from '@idealmediaworks/lookingglass-ui-framework';
import ChannelDays from '../containers/channelsArea/channelDays/ChannelDays';

const PanelChannels: React.FC = (): JSX.Element => {
  return (
    <Panel>
      <ChannelDays />
    </Panel>
  );
};

export default PanelChannels;
